(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ResourceTypeDialogController", ResourceTypeDialogController);

    ResourceTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "ResourceType",
        "User",
        "ResourceTypeSearch",
        "AllCustomResourceTypeAttribute",
    ];

    
    function ResourceTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        ResourceType,
        User,
        ResourceTypeSearch,
        AllCustomResourceTypeAttribute
    ) {
        var vm = this;
        //resourcetype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.resourceType = entity;
        vm.resourceTypeImageName = resourceTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customResourceTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function resourceTypeImageName(image) {
            vm.resourceType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomResourceTypeAttribute.getAll(function (response) {
                vm.customResourceTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customResourceTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.resourceType.resourceTypeAttribute != null &&
            vm.resourceType.resourceTypeAttribute.length != 0
        ) {
            vm.items = vm.resourceType.resourceTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.resourceCategory == null) {
                value.resourceCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.resourceType.id !== null) {
                vm.resourceType.resourceTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.resourceType.resourceTypeAttribute.push({
                        resourceCategory: vm.items[i].resourceCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        resourceTypeAttribOrder: vm.items[i].resourceTypeAttribOrder
                    });
                }
                ResourceType.update(vm.resourceType, onSaveSuccess, onSaveError);
            } else {
                vm.resourceType.resourceTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.resourceType.resourceTypeAttribute.push({
                        resourceCategory: vm.items[i].resourceCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        resourceTypeAttribOrder: vm.items[i].resourceTypeAttribOrder
                    });
                }
                ResourceType.save(vm.resourceType, onSaveSuccess, onSaveError);
            }
        }

        $("#resourceTypeImage").change(function () {
            var filesSelected = document.getElementById("resourceTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.resourceType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:resourceTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("resource-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();
